import {
  buildElationUrlFeedItem,
  buildElationUrlPatient,
} from '@seen/core/elation'
import { IconExternalLink } from '@tabler/icons-react'
import type { ReactNode } from 'react'
import { DropdownMenuItem } from '#src/components/core/dropdown-menu/DropdownMenuItem.tsx'
import { useConfig } from '#src/contexts/config/useConfig.ts'
import { useCurrentPractitionerPerms } from '#src/hooks/useCurrentPractitionerPerms.ts'
import { usePortalStore } from '#src/hooks/usePortalStore.ts'

export interface DropdownMenuElationLinkItemProps {
  elationPatientId: number | string
  elationFeedItemId?: number | string
}

export function DropdownMenuElationLinkItem({
  elationPatientId,
  elationFeedItemId,
}: DropdownMenuElationLinkItemProps): ReactNode {
  const showLinkOverlay = usePortalStore((state) => state.showLinkOverlay)
  const config = useConfig()
  const { isTech } = useCurrentPractitionerPerms()
  if (!showLinkOverlay && !isTech) {
    return null
  }

  const href = elationFeedItemId
    ? buildElationUrlFeedItem({
        elationBaseUrl: config.elationBaseUrl,
        elationPatientId,
        elationFeedItemId,
      })
    : buildElationUrlPatient({
        elationBaseUrl: config.elationBaseUrl,
        elationPatientId,
      })

  return (
    <DropdownMenuItem asChild>
      <a
        href={href}
        target="_blank"
        rel="noreferrer"
        className="flex items-center gap-2"
      >
        <IconExternalLink className="-mt-px size-4 text-foreground-secondary" />
        Open in Elation
      </a>
    </DropdownMenuItem>
  )
}
